import { render, staticRenderFns } from "./ClassifyCourseslist.vue?vue&type=template&id=4cb6383b&scoped=true"
import script from "./ClassifyCourseslist.vue?vue&type=script&lang=js"
export * from "./ClassifyCourseslist.vue?vue&type=script&lang=js"
import style0 from "./ClassifyCourseslist.vue?vue&type=style&index=0&id=4cb6383b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb6383b",
  null
  
)

export default component.exports